"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.BasketLink = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  height: 65,
  position: 'absolute',
  zIndex: 2,
  display: 'flex',
  padding: theme.spacing(0, 4),
  boxSizing: 'border-box',
  alignItems: 'center',
  width: '100%',
  background: 'linear-gradient(to bottom, #fff 20%, rgba(255,255,255,0.9) 30%)',
  color: theme.palette.text.secondary
}));
const BasketLink = exports.BasketLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none'
}));